/*
 * (C) 2026 BeyondDemise, All Rights Reserved.
 *
 * BaCustomerDetail — read-only drawer rendering a single AdminUserView. A0 has
 * no mutations: the detail is exactly the same allow-list record the list row
 * shows. Lit light-DOM.
 */

import { LitElement, html, type TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { type AdminUserView } from '../services/adminApi.js';

@customElement('ba-customer-detail')
export class BaCustomerDetail extends LitElement {
  @state() private user: AdminUserView | null = null;
  @state() private open = false;

  override createRenderRoot(): HTMLElement {
    return this;
  }

  /** Fill the drawer with a record and open it. */
  show(view: AdminUserView): void {
    this.user = view;
    this.open = true;
  }

  private onHide(): void {
    this.open = false;
  }

  override render(): TemplateResult {
    const u = this.user;
    return html`
      <wa-drawer
        label="Customer detail"
        data-testid="drawer"
        ?open=${this.open}
        @wa-hide=${this.onHide}
      >
        ${
          u
            ? html`
                <dl>
                  <dt>Email</dt>
                  <dd data-testid="email">${u.email}</dd>
                  <dt>Full name</dt>
                  <dd>${u.fullName ?? '—'}</dd>
                  <dt>Salutation</dt>
                  <dd>${u.salutation ?? '—'}</dd>
                  <dt>Groups</dt>
                  <dd>
                    ${u.groups.map(g => html`<wa-badge>${g}</wa-badge> `)}
                  </dd>
                  <dt>Authentication</dt>
                  <dd>
                    ${u.authenticationTypes.map(
                      a => html`<wa-badge variant="neutral">${a}</wa-badge> `
                    )}
                  </dd>
                  <dt>Custodians</dt>
                  <dd>${u.custodianCount}</dd>
                </dl>
              `
            : html`<p>No customer selected.</p>`
        }
      </wa-drawer>
    `;
  }
}
